import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import worldArea from '../../../worldMap/worldArea';
import nameMap from '../../../worldMap/worldMap.json';

let initZoom = 1;

class Map extends PureComponent {
    static propTypes = {
        data: PropTypes.object,
        gpsData: PropTypes.object,
        outputList: PropTypes.array,
        devicetype: PropTypes.string,
    };

    map = null;

    async componentDidMount() {
        // 引入 ECharts 主模块
        this.echarts = await import('echarts/lib/echarts');
        await import('echarts/lib/coord/geo/Geo');

        // 引入世界地图
        await import('echarts/map/js/world');
        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');

        this.mapRender(1);
    }

    mapRender = async (zoom, roam) => {
        const {
            data: { all, list },
            gpsData,
            outputList,
        } = this.props;

        if (this.map) {
            this.map.dispose();
        }

        this.map = this.echarts.init(document.getElementById('world'));

        let worldMap = await import('./world');

        worldMap = worldMap.default;

        this.echarts.registerMap('worldMap', worldMap);

        let mapData = [];

        const yd = [...all, ...list].map(item => ({
            name: item.name1 === '全国' ? '中国' : item.name2,
            quezhen: item.quezhen || 0,
            zhiyu: item.zhiyu || 0,
            siwang: item.siwang || 0,
        }));

        mapData = yd.map(item => ({
            name: item.name,
            itemStyle: {
                normal: {
                    color: this.getWorldColor(item.quezhen),
                    borderColor: item.name === '中国' ? '#600A0A' : '#ffffff', // 边框颜色
                    borderWidth: item.name === '中国' ? 1.5 : 0.5, // 边框线宽
                },
            },
            num: [item.quezhen, item.zhiyu, item.siwang],
        }));

        const gps = typeof gpsData === 'string' ? JSON.parse(gpsData) : gpsData;

        const routes = outputList.filter(item => gps[item]).map(item => [{ coord: gps[item] }, { coord: gps['中国'] }]);

        const option = {
            tooltip: {
                show: false,
            },
            geo: {
                map: 'worldMap',
                roam,
                zoom,
                scaleLimit: {
                    max: 5,
                    min: 1,
                },
                left: 0,
                right: 0,
                top: 20,
                itemStyle: {
                    normal: {
                        areaColor: '#EEEEEE',
                        borderColor: '#A1A5AC', // 边框颜色
                        borderWidth: 0.5, // 边框线宽
                    },
                },
                label: {
                    show: false,
                },
                data: mapData,
                nameMap,
                regions: [
                    {
                        name: '中国',
                        itemStyle: {
                            areaColor: '#600A0A',
                            color: '#600A0A',
                        },
                    },
                ],
            },
            series: [
                {
                    type: 'lines',
                    zlevel: 2,
                    effect: {
                        show: true,
                        period: 4, // 箭头指向速度，值越小速度越快
                        trailLength: 0.02, // 特效尾迹长度[0,1]值越大，尾迹越长重
                        symbol: 'arrow', // 箭头图标
                        symbolSize: 3, // 图标大小
                    },
                    lineStyle: {
                        normal: {
                            width: 1, // 尾迹线条宽度
                            color: '#AF202C',
                            opacity: 1, // 尾迹线条透明度
                            curveness: 0.3, // 尾迹线条曲直度
                        },
                    },
                    data: routes,
                },
            ],
        };

        this.map.setOption(option);
    };

    getInfoUrl = areaName => {
        const { devicetype } = this.props;

        let url = '';
        let code = '';

        Object.keys(worldArea).every(item => {
            if (areaName === item) {
                code = worldArea[item].code;

                return false;
            }

            return true;
        });

        if (devicetype === 'share') {
            url = `https://ishare.ifeng.com/c/s/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else if (devicetype === 'client') {
            url = `https://news.ifeng.com/c/specialClient/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else {
            url = `https://news.ifeng.com/c/special/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = `https://news.ifeng.com/c/vivo/7uLyp1412jw?code=${code}`;
        }

        return url;
    };

    getChinaUrl = () => {
        const { devicetype } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = 'https://ishare.ifeng.com/c/s/7tPlDSzDgVk?needpage=1&webkit=1';
        } else if (devicetype === 'client') {
            url = 'https://news.ifeng.com/c/specialClient/7tPlDSzDgVk?needpage=1&webkit=1';
        } else {
            url = 'https://news.ifeng.com/c/special/7tPlDSzDgVk?needpage=1&webkit=1';
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = 'https://news.ifeng.com/c/vivo/7tPlDSzDgVk';
        }

        return url;
    };

    getWorldColor = num => {
        let color = '#F2DADB';

        if (num > 9999) {
            color = '#600A0A';
        } else if (num > 999) {
            color = '#9E0707';
        } else if (num > 99) {
            color = '#BF5A53';
        } else if (num > 9) {
            color = '#CE8A86';
        } else if (num === 0) {
            color = '#ffffff';
        }

        return color;
    };

    handleZoomIn = () => {
        if (initZoom === 5) {
            return;
        }

        initZoom++;

        this.mapRender(initZoom, true);
    };

    handleZoomOut = () => {
        if (initZoom === 1) {
            return;
        }

        initZoom--;

        this.mapRender(initZoom, initZoom > 1);
    };

    handleReset = () => {
        initZoom = 1;

        this.mapRender(initZoom);
    };

    render() {
        return (
            <Fragment>
                <div className={styles.box}>
                    <div id="world" className={styles.map} />
                    <div className={styles.toolbox}>
                        <a onClick={this.handleZoomIn}>
                            <span>+</span>
                        </a>
                        <a onClick={this.handleZoomOut}>
                            <span>-</span>
                        </a>
                        <a onClick={this.handleReset}>
                            <span>重置</span>
                        </a>
                    </div>
                </div>
                <p className={styles.tt}>* 放大移动可查看地图详情</p>
            </Fragment>
        );
    }
}

export default errorBoundary(Map);
